module.exports = __webpack_public_path__ + "static/img/sy-7.99beac5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/sy-7.png
// module id = 1usv
// module chunks = 63